module.exports = __webpack_public_path__ + "img/description.fadede0f.svg";